import { type SliderCtaWithBadgesSlideMapped } from "@services/wordpress/wordpress.types";
import { KeenSliderComponent } from "../../KeenSlider";
import { Slide } from "./Slide";
import Icons from "@components/icons";
import "./index.scss";

export const Slider = ({ slides }: {
  slides: SliderCtaWithBadgesSlideMapped[];
}) => {
  slides = [...slides, ...slides];

  return (
    <div className="slider-cta-with-badges-slider">
      <KeenSliderComponent
        className="slider-cta-with-badges-slider__container"
        options={{
        mode: "free",
        breakpoints: {
          870: {
            slides: {
              spacing: 24,
            },
          },
        },
        slides: {
          perView: "auto",
          spacing: 16,
        },
        loop: true,
        autoplay: {
          enabled: false,
        },
        navigation: {
          enabled: true,
          prevButton: ".slider-cta-with-badges-slider__navigation-button--prev",
          nextButton: ".slider-cta-with-badges-slider__navigation-button--next",
        },
      }}
    >
      {slides.map((slide, index) => (
          <Slide key={`slider-cta-with-badges-slider-slide-${index}`} slide={slide} />
        ))}
      </KeenSliderComponent>

      <div className="slider-cta-with-badges-slider__navigation">
        <button className="slider-cta-with-badges-slider__navigation-button slider-cta-with-badges-slider__navigation-button--prev">
          <Icons.IconLeft />
        </button>
        <button className="slider-cta-with-badges-slider__navigation-button slider-cta-with-badges-slider__navigation-button--next">
          <Icons.IconRight />
        </button>
      </div>
    </div>
  );
};
